import { actions } from './actions';
import { NAME as ROOT_NAME } from './reducer';
import { GENERIC_SAVE_ALERT, saveOf } from './saving';

// Если сохранение формы не удалось (нет связи, сервер ответил ошибкой) и само оно ничего не
// показало, человек видит «Не удалось сохранить». Свои сообщения сохранений (например, «Компания с
// таким названием уже существует») остаются: если после запроса показано хоть одно сообщение, общее
// не добавляется. Ставится в store после apiMiddleware: действия запроса приходят уже от него.
export const saveFeedback = (store) => {
  const alertsAtRequest = {};
  return (next) => (action) => {
    const save = action ? saveOf(action.type) : null;
    if (!save) return next(action);

    if (save.stage === 'REQUEST') {
      alertsAtRequest[save.name] = store.getState()[ROOT_NAME].alertCount;
    }
    const result = next(action);
    if (save.stage === 'FAILURE' && alertsAtRequest[save.name] === store.getState()[ROOT_NAME].alertCount) {
      store.dispatch(actions.showAlert(GENERIC_SAVE_ALERT));
    }
    return result;
  };
};
